module.exports = __webpack_public_path__ + "fa-regular-400.ttf?766913e6c0088ab8c9f73e18b4127bc4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/webfonts/fa-regular-400.ttf
// module id = 1454
// module chunks = 0